import { CSSObject } from '@chakra-ui/react';

export const FlexTextContainer: CSSObject = {
  maxWidth: 'unset',
};
